import {
    SURVEY_EDITOR_RATING_RIGHT_CHANGE_OPTION_COUNT_AND_SHAPE,
} from "../../../../../constants";

export const RatingScaleChangeOptionCountAndShape = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: SURVEY_EDITOR_RATING_RIGHT_CHANGE_OPTION_COUNT_AND_SHAPE, payload });
    }
};